<template>
  <div>
    <v-data-iterator
      :no-data-text="noDataText"
      :items="dataDisponibilidade"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-spacer />
          <v-col cols="4" class="mr-2">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>

      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          disable-sort
        >
          <template v-slot:[`item.event`]="{ item }">
            <div :class="`${getColor(item.event)}--text`">
              {{ item.event }}
            </div>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Itens: {{ initialItem }} - {{ finalItem }} de {{ dataDisponibilidade.length }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import moment from 'moment'

import ListPagination from '@/componentes/ListPagination'

export default {
  name: 'ListaInterna',
  props: ['valuesTable'],
  components: { ListPagination },
  data: () => ({
    noDataText: process.env.VUE_APP_NO_DATA_TEXT,
    noResultsText: process.env.VUE_APP_NO_RESULTS_TEXT,
    moment: moment,
    dataDisponibilidade: [],
    itemsPerPage: 20,
    search: '',
    page: 1,
    headers: [
      {
        text: 'Data/Hora',
        value: 'dataHora',
        align: 'left',
      },
      {
        text: 'Evento',
        value: 'event',
        align: 'left',
      },
      {
        text: 'Ramal Logado',
        value: 'ramal',
        align: 'left',
      },
      {
        text: 'Realizado Por',
        value: 'quemRealizou',
        align: 'left',
      },
    ],
  }),

  computed: {
    numberOfPages() {
      return Math.ceil(this.dataDisponibilidade.length / this.itemsPerPage)
    },

    initialItem() {
      return 1 + (this.page - 1) * 20
    },

    finalItem() {
      if (this.initialItem + 19 > this.dataDisponibilidade.length) {
        return this.dataDisponibilidade.length
      }
      return this.initialItem + 19
    },
  },

  methods: {
    getColor(event) {
      if (event === 'LOGIN' || event === 'UNPAUSE') {
        return 'font-weight-bold green'
      }
      if (event === 'LOGOUT') {
        return 'font-weight-bold red'
      }
      return 'font-weight-bold orange'
    },
    firstPage() {
      if (this.page > 1) {
        this.page = 1
      }
    },
    formerPage() {
      if (this.page > 1) {
        this.page = this.page - 1
      }
    },
    nextPage() {
      if (this.page < this.numberOfPages) {
        this.page = this.page + 1
      }
    },
    lastPage() {
      if (this.page < this.numberOfPages) {
        this.page = this.numberOfPages
      }
    },
  },
  watch: {
    valuesTable: {
      deep: true,
      immediate: true,
      handler() {
        if (typeof this.valuesTable !== 'undefined') {
          this.dataDisponibilidade.splice(0)
          this.valuesTable.forEach(valoresTabela => {
            let eventoFormatado
            if (valoresTabela.evento === 'pause') {
              eventoFormatado = `${valoresTabela.evento.toUpperCase()} - ${valoresTabela.description}`
            } else {
              eventoFormatado = `${valoresTabela.evento.toUpperCase()}`
            }
            this.dataDisponibilidade.push({
              dataHora: moment(valoresTabela.horaData, 'DD-MM-YYYY HH:mm:ss').format('DD/MM/YYYY HH:mm:ss'),
              event: eventoFormatado,
              ramal: valoresTabela.ramal,
              quemRealizou: valoresTabela.realizouEvento,
            })
          })
        }
      },
    },
  },
}
</script>
